import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsNewbuildingBrokerEntryRedesignEnabled } from '../../hooks/broker';
import {
  selectIsPartnerRewardsRegistrationStatusAvailable,
  selectIsBrokerAvailable,
} from '../../selectors/newbuildingBroker';
import { BrokerBannerContainer } from '../BrokerBanner';
import { Promo } from '../Promo';

export const BannerContainer = () => {
  const isNewbuildingBrokerEntryRedesignEnabled = useIsNewbuildingBrokerEntryRedesignEnabled();
  const isRegistrationStatusAvailable = useSelector(selectIsPartnerRewardsRegistrationStatusAvailable);
  const isBrokerAvailable = useSelector(selectIsBrokerAvailable);
  const isBrokerBannerVisible =
    (isRegistrationStatusAvailable || isBrokerAvailable) && isNewbuildingBrokerEntryRedesignEnabled;

  if (isBrokerBannerVisible) {
    return <BrokerBannerContainer />;
  }

  return <Promo />;
};
